import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Facebook from "../icons/facebook.svg";
import Linkedin from "../icons/linkedin.svg";
import LanguageApi from "../components/Language";
import Cookies from "universal-cookie";
import Logo from "../img/logo.png";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const cookies = new Cookies();

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});
const Footer = () => {
  const { home, Corporate, contact, slogan, language } =
    LanguageApi();

  const languageCookie = cookies.get("language");
  const [age, setAge] = React.useState(languageCookie);
  const handleChange = (event) => {
    setAge(event.target.value);
    cookies.set("language", event.target.value, { path: "/" });
    window.location.reload(false);
  };

  return (
    <div className="footer">
      <div className="footer-line"></div>
      <div className="footer-icons">
        <a
          href="https://www.facebook.com/Aven-Kimyevi-Maddeler-132460547545763"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Facebook} alt="footer icon" />
        </a>
        <a
          href="https://www.linkedin.com/company/aven-kimya/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Linkedin} alt="footer icon" />
        </a>
      </div>
      <div className="footer-links">
        <Link to={"/"}>{home}</Link>
        <Link to={"/our"}>{Corporate}</Link>
        <Link to={"/contact"}>{contact}</Link>
      </div>
      <ThemeProvider theme={darkTheme}>
        <Box
          sx={{
            minWidth: 180,
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: 5,
            paddingBottom: 5,
          }}
        >
          <FormControl>
            <InputLabel id="demo-simple-select-label">{language}</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label={language}
              onChange={handleChange}
            >
              <MenuItem value={"tr"}>Türkçe</MenuItem>
              <MenuItem value={"en"}>English</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </ThemeProvider>
      <div className="footer-credits">
        <div className="credit-1">© Aven Kimyevi Maddeler</div>
        <div className="credit-2">
          <img src={Logo} alt="aven-logo" />
        </div>
        <div className="credit-3">{slogan}</div>
      </div>
    </div>
  );
};

export default Footer;
